module.exports = __webpack_public_path__ + "img/xcm.4185c012.png";